var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { IconButton, SwipeableDrawer, } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import { mergeClasses } from '@material-ui/styles';
import Grid from '@material-ui/core/Grid';
const useStyles = makeStyles((theme) => createStyles({
    paper: {
        borderRadius: theme.spacing(6, 6, 0, 0),
        paddingTop: theme.spacing(5),
        paddingBottom: `max(${theme.spacing(5)}px , env(safe-area-inset-top))`,
        paddingLeft: theme.spacing(4),
        paddingRight: theme.spacing(4),
    },
}));
const BottomSheetPanel = (_a) => {
    var { classes: newClasses, children, onClose, title, closeButtonProps, closeIcon: CloseButtonIcon = CloseIcon } = _a, props = __rest(_a, ["classes", "children", "onClose", "title", "closeButtonProps", "closeIcon"]);
    const classes = mergeClasses({
        baseClasses: useStyles(),
        newClasses: newClasses,
        Component: SwipeableDrawer,
    });
    return (React.createElement(SwipeableDrawer, Object.assign({ anchor: "bottom", classes: classes, onClose: onClose, disableSwipeToOpen: true }, props),
        React.createElement(Grid, { container: true, justify: "space-between", alignContent: "center", alignItems: "center" },
            React.createElement(Grid, { item: true, xs: true }, title),
            React.createElement(Grid, { item: true },
                React.createElement(IconButton, Object.assign({ edge: "end", onClick: onClose }, closeButtonProps),
                    React.createElement(CloseButtonIcon, null)))),
        children));
};
export default BottomSheetPanel;
